var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.small)?_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"small",attrs:{"src":"assets/logo.png","alt":"Loot Logger Logo"},on:{"click":_vm.onClick}})]):_c('img',{attrs:{"src":"assets/logo.png","alt":"Loot Logger Logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }